import { render, staticRenderFns } from "./WorkflowDashboard.vue?vue&type=template&id=6af6f5ac"
import script from "./WorkflowDashboard.vue?vue&type=script&lang=js"
export * from "./WorkflowDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports